// extracted by mini-css-extract-plugin
module.exports = {"grade-list":"grade-list_2--s","tabs":"tabs_33ap","grade-scroll":"grade-scroll_3jEf","grade-item":"grade-item_1avk","intro":"intro_14vl","tab":"tab_1lFI","active":"active_1VZ1"};